import { useTheme } from "styled-components";
import { Typography } from "@flash-tecnologia/hros-web-ui-v2";
import React from "react";
import { Box } from "../../atoms";

export interface BigNumberProps {
  title?: string;
  value?: string;
  children?: React.ReactNode;
}

export const BigNumber = ({ children, title, value }: BigNumberProps) => {
  const theme = useTheme();

  return (
    <Box
      $border={`${theme.borders.width.xs2} solid ${theme.colors.neutral[90]}`}
      $borderRadius={theme.borders.radius.m}
      flexDirection="column"
      gap="xs2"
      $px="xs"
      $py="xs"
      $width="100%"
    >
      <div>
        {title && (
          <Typography.Body4 color="neutral.50" weight={600}>
            {title}
          </Typography.Body4>
        )}
        {value && (
          <Typography.Headline5 color="neutral.30" weight={700}>
            {value}
          </Typography.Headline5>
        )}
      </div>
      {children}
    </Box>
  );
};
